<template>
  <ul class="pagination">
    <li class="pagination-item" v-if="maxVisibleButtons < totalPages">
      <button
        type="button"
        class="btn btn-secondary col-md"
        @click="onClickFirstPage"
        :disabled="isInFirstPage"
      >
        {{ $t('pagination.first') }}
      </button>
    </li>

    <li class="pagination-item" v-if="maxVisibleButtons < totalPages">
      <button
        class="btn btn-secondary col-md"
        type="button"
        @click="onClickPreviousPage"
        :disabled="isInFirstPage"
      >
        {{ $t('pagination.previous') }}
      </button>
    </li>

    <!-- Visible Buttons Start -->

    <li
      v-for="page in pages"
      :key="page.name"
    >
      <button
        class="pagination-item btn btn-secondary"
        type="button"
        @click="onClickPage(page.name)"
        :disabled="page.isDisabled"
        :class="{ active: isPageActive(page.name) }"
        v-if="totalPages > 1"
      >
        {{ $n(page.name) }}
      </button>
    </li>

    <!-- Visible Buttons End -->

    <li class="pagination-item">
      <button
        type="button"
        class="btn btn-secondary col-md"
        @click="onClickNextPage"
        :disabled="isInLastPage"
        v-if="maxVisibleButtons < totalPages"
      >
        {{ $t('pagination.next') }}
      </button>
    </li>

    <li>
      <button
        class="pagination-item btn btn-secondary col-md"
        type="button"
        @click="onClickLastPage"
        :disabled="isInLastPage"
        v-if="maxVisibleButtons < totalPages"
      >
        {{ $t('pagination.last') }}
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Pagination',
  template: '#pagination',
  props: {
    totalPages: {
      type: Number,
      required: true,
    },
    totalCount: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      maxVisibleButtons: 3,
    };
  },
  computed: {
    startPage() {
      // When on the first page
      if (this.currentPage === 1) {
        return 1;
      }

      // When on the last page
      if (this.currentPage === this.totalPages) {
        return this.totalPages - this.maxVisibleButtons;
      }

      // When inbetween
      return this.currentPage - 1;
    },
    pages() {
      const range = [];

      for (
        let i = this.startPage;
        i <= Math.min(this.startPage + this.maxVisibleButtons, this.totalPages);
        i += 1
      ) {
        if (i > 0) {
          range.push({
            name: i,
            isDisabled: i === this.currentPage,
          });
        }
      }

      return range;
    },
    isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage() {
      return this.currentPage === this.totalPages;
    },
  },
  methods: {
    onClickFirstPage() {
      this.$emit('pagechanged', 1);
    },
    onClickPreviousPage() {
      this.$emit('pagechanged', this.currentPage - 1);
    },
    onClickPage(page) {
      this.$emit('pagechanged', page);
    },
    onClickNextPage() {
      this.$emit('pagechanged', this.currentPage + 1);
    },
    onClickLastPage() {
      this.$emit('pagechanged', this.totalPages);
    },
    isPageActive(page) {
      return this.currentPage === page;
    },
  },
};
</script>

<style>
.pagination {
  list-style-type: none;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
}

.pagination-item {
  display: inline-block;
  justify-content: center;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-right: 5px;
  margin-left: 5px;
}

.active {
  background-color: #4AAE9B;
  color: #ffffff;
}</style>
